import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import pluralize from 'pluralize';
import { useSelector } from 'react-redux';

import { DATE_FORMAT_WITH_TIME } from '../../../../../../constants/dates';
import getConfig from '../../../../../../util/config';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../../../util/photo';
import WebGalleryCard from '../../../WebGalleryCard';
import { prependAccountSlug } from '../../../../../../util/account';
import WebGalleryThumbnailActions from '../../../WebGalleryThumbnailActions';
import { ALBUM_PRIVACY } from '../../../../../../constants/albums';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }),
  photoGroup: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    photos: PropTypes.shape({
      total: PropTypes.number,
    }),
  }),
};

const WebGalleryPhotoGroupCard = ({ album, photoGroup }) => {
  const linkTo = prependAccountSlug(
    `/galleries/view/album/${album.id}/subalbums/${photoGroup.id}`,
    album,
  );
  const thumbs =
    photoGroup.cover_photos.records.length > 0
      ? photoGroup.cover_photos.records[0].thumbnail_urls
      : undefined;

  const { breadcrumbNavigationEnabled } = useSelector(
    state => state.galleries.layout,
  );

  const config = getConfig();

  const thumbnailUrl = getThumbBySize(
    thumbs,
    IMAGE_SIZE_CODE.MEDIUM2X,
    // Important for when using local cache
    true,
  )?.url;

  const lastUploadedAt = '';
  const totalPhotos = photoGroup?.photos?.total ?? 0;

  return (
    <WebGalleryCard
      thumbnailUrl={thumbnailUrl}
      linkTo={linkTo}
      linkProps={{
        rel: album?.privacy === ALBUM_PRIVACY.PRIVATE ? 'nofollow' : undefined,
      }}
      title={photoGroup.name}
      subtitle={
        totalPhotos > 0
          ? `${totalPhotos} ${pluralize('Photo', totalPhotos)}`
          : undefined
      }
      note={
        lastUploadedAt
          ? `Last Updated: ${moment(lastUploadedAt).format(
              DATE_FORMAT_WITH_TIME,
            )}`
          : undefined
      }
      thumbnailActions={
        breadcrumbNavigationEnabled ? (
          <WebGalleryThumbnailActions
            albumId={album.id}
            url={`${config.app.baseUrl}${linkTo}`}
            quote="Check out this awesome album!"
            entity={album}
          />
        ) : undefined
      }
    />
  );
};

WebGalleryPhotoGroupCard.propTypes = propTypes;

export default WebGalleryPhotoGroupCard;
